import updateSingleDatasetInView from './updateSingleDatasetInView';
export default function updateMultipleDatasetsInView(view, data) {
  Object.keys(data).forEach(name => {
    updateSingleDatasetInView(view, name, data[name]);
  });
}